<template>
  <RevCard class="p-24 md:p-32">
    <h2 class="heading-2 mb-8">
      {{ i18n(translations.title) }}
    </h2>

    <h3 class="body-1 mb-8">
      {{ i18n(translations.subtitle) }}
    </h3>

    <AddressRulesTable
      :addressRules
      class="mb-16"
      @delete-item="handleDeleteItem"
      @edit-item="handleEditItem"
    />

    <RevButton variant="secondary" @click="handleAddNewRule">
      {{ i18n(translations.addNewRule) }}
    </RevButton>
  </RevCard>

  <AddressRulesModalForm
    :rule-to-edit="addressRuleToEdit"
    @rule-submitted="fetchAddressRules"
  />

  <DeleteAddressRuleModal
    :rule-id="addressRuleIdToDelete"
    @rule-deleted="fetchAddressRules"
  />
</template>

<script setup lang="ts">
import { type Ref, ref } from 'vue'

import { merchantsAPI } from '@backmarket/http-api'
import { $httpFetch } from '@backmarket/nuxt-module-http/$httpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { openModal } from '@ds/components/ModalBase'

import {
  ADDRESS_RULE_DELETE_MODAL_NAME,
  ADDRESS_RULE_FORM_MODAL_NAME,
} from './AddressRules.constants'
import translations from './AddressRules.translations'
import AddressRulesModalForm from './components/AddressRulesModalForm/AddressRulesModalForm.vue'
import AddressRulesTable from './components/AddressRulesTable/AddressRulesTable.vue'
import DeleteAddressRuleModal from './components/DeleteAddressRuleModal/DeleteAddressRuleModal.vue'

const i18n = useI18n()
const addressRules: Ref<merchantsAPI.AddressRule[]> = ref([])
const addressRuleToEdit: Ref<merchantsAPI.AddressRule | Record<string, never>> =
  ref({})
const addressRuleIdToDelete = ref('')

async function fetchAddressRules() {
  const { results } = await $httpFetch(merchantsAPI.getAddressRules)

  addressRules.value = results || []
}

function handleAddNewRule() {
  addressRuleToEdit.value = {}
  openModal(ADDRESS_RULE_FORM_MODAL_NAME)
}

function handleEditItem(addressRule: merchantsAPI.AddressRule) {
  addressRuleToEdit.value = addressRule
  openModal(ADDRESS_RULE_FORM_MODAL_NAME)
}

function handleDeleteItem(addressRule: merchantsAPI.AddressRule) {
  addressRuleIdToDelete.value = addressRule.id
  openModal(ADDRESS_RULE_DELETE_MODAL_NAME)
}

fetchAddressRules()
</script>
